import Pricing from "./Pricing";
import store from "@/store";
const EssentialsScreen = () => import("./Essentials/PricingEssentials");
const InsightsScreen = () => import("@/components/Pricing/Insights/PricingInsights");
const CartScreen = () => import("./Cart");

const EssentialPlans = [
  "recruiting-basic-monthly",
  "recruiting-basic-annual",
  "imlca-recruits-pro-monthly",
  "imlca-recruits-pro-annual",
];

const InsightsPlans = [
    'silver',
    'silver-one-time',
    'gold',
    'gold-one-time',
    'platinum',
    'platinum-one-time',
    'imlca-recruits-silver',
    'imlca-recruits-silver-one-time',
    'imlca-recruits-gold',
    'imlca-recruits-gold-one-time',
    'imlca-recruits-platinum',
    'imlca-recruits-platinum-one-time',
];

export default {
    path: '/pricing',
    component: Pricing,
    children: [
        {
            path: 'essentials',
            name: 'Pricing/Essentials',
            alias: '',
            components: { options: EssentialsScreen },
            beforeEnter: (to, from, next) => {
                store.commit("pricing/setActiveTab", 0);
                store.commit("pricing/setRosterNeedsEnabled", window.pricing.rosterNeedsFiltersEnabled);
                window.scrollTo({ top: 0, behavior: 'smooth'})
                next();
            }
        },
        {
            path: 'essentials/:plan',
            name: 'Pricing/Essentials/Review',
            beforeEnter: (to, from, next) => {
                if (!EssentialPlans.includes(to.params.plan)) {
                    next({ name: 'Pricing/Essentials' });
                } else {
                    next();
                }
            },
            components: { default: Pricing, options: CartScreen },
        },
        {
            path: 'insights',
            name: 'Pricing/Insights',
            components: { options: InsightsScreen },
            beforeEnter: (to, from, next) => {
                store.commit("pricing/setActiveTab", 1);
                store.commit("pricing/setRosterNeedsEnabled", window.pricing.rosterNeedsFiltersEnabled);
                window.scrollTo({ top: 0, behavior: 'smooth'})
                next();
            }
        },
        {
            path: 'insights/:plan',
            name: 'Pricing/Insights/Review',
            beforeEnter: (to, from, next) => {
                if (!InsightsPlans.includes(to.params.plan)) {
                    next({ name: 'Pricing/Insights' });
                } else {
                    next();
                }
            },
            components: { default: Pricing, options: CartScreen },
        },
        { path: '*', redirect: '/pricing' },
    ]
};
